module.exports = __webpack_public_path__ + "img/2.80504cd9.png";